import React, { useCallback } from "react";
import { useGoogleAnalytics } from "../../hooks/useGoogleAnalytics";
import { useIsPreviewMode } from "../../hooks/useIsPreviewMode";
import { IconButton } from "../icon-button";

export function usePreviewButton() {
	const [, setIsPreviewMode] = useIsPreviewMode();
	const googleAnalytics = useGoogleAnalytics();

	const onClick = useCallback(() => {
		googleAnalytics.trackEventToGa({
			trackingAction: "PreviewClicked",
		});
		setIsPreviewMode(true);
	}, [googleAnalytics, setIsPreviewMode]);

	return {
		iconName: "preview",
		onClick,
	} as const;
}

export function PreviewButton() {
	const previewProps = usePreviewButton();
	return <IconButton {...previewProps} elevated />;
}
